import * as React from 'react';
import {
    Button, CircularProgress, Divider,
    Grid, InputAdornment, ListItemIcon, MenuItem, TextField,
} from "@mui/material";
import {
    AddCard,
    ArrowBackIos, ArrowForwardIos, Payment,
} from "@mui/icons-material";
import Body from "../global/Body";
import reducer from "../../store/request";
import withReducer from "../../store/withReducer";
import {memo, useEffect, useState} from "react";
import {selectRequestState, setItem, setStep} from "../../store/request/stateSlice";
import {useDispatch, useSelector} from "react-redux";
import Typography from "@mui/material/Typography";
import {coin} from "../../inc/Utils";
import Api from "../../inc/Api";
import Toast from "../../inc/Toast";
import Alert from "../../inc/Alert";
import DetailService from "./components/DetailService";

function Step4() {

    const {item} = useSelector(selectRequestState);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [fareProduct, setFateProduct] = useState(null);
    const [payments, setPayments] = useState(null);
    const [code, setCode] = useState('');
    const [promoRsp, setPromoRsp] = useState(undefined);

    useEffect(loadFare, []);

    function loadFare() {
        setLoading(true);

        let param = {
            org         : item.org,
            dst         : item.dst,
            id_product  : item.product.id,
            date_start  : item.date_start,
            date_return : item.date_return,
            type_request: item.type_request,
            capacity_1  : item.capacity_1,
        };

        Api.post(`/client/widgets/${item.id_widget}/fare`, param, rsp => {
            setLoading(false);
            setFateProduct(rsp.fare_product);
            setPayments(rsp.payments);
        }, false);
    }

    function addPromotion() {
        setLoading(true);
        setPromoRsp(null);
        Api.post(`/client/me/addPromotion`, {code}, rsp => {
            if (rsp.ok) {
                loadFare();
                setPromoRsp(undefined);
                Toast.success(rsp.msg);
            } else {
                setLoading(false);
                setPromoRsp(rsp);
            }
        }, false);
    }

    function createService() {
        setLoading(true);

        let param = {
            org         : item.org,
            dst         : item.dst,
            id_product  : item.product.id,
            date_start  : item.date_start,
            date_return : item.date_return,
            type_request: item.type_request,
            capacity_1  : item.capacity_1,
            notes       : item.notes,
            id_payment  : item.id_payment,
        };

        Api.post(`/client/widgets/${item.id_widget}/createService`, param, rsp => {
            setLoading(false);
            if (rsp.ok) {
                dispatch(setItem({id: rsp.id}));
                dispatch(setStep(rsp.msg === 'go_payment_prepaid' ? '5_prepaid' : '6_paid'));
            } else {
                Alert.error(rsp.msg);
            }
        }, 'Creando reserva...');
    }

    return (
        <Body title="Confirma tu reserva">

            <Grid container spacing={3}>

                <Grid xs={12} sm={6} item>

                    <DetailService/>

                </Grid>

                <Grid xs={12} sm={6} item>

                    <Grid container spacing={3}>

                        <Grid xs={12} item>

                            <TextField
                                label="Método de pago"
                                value={item.id_payment === '' ? '' : String(item.id_payment)}
                                onChange={e => {
                                    if (e.target.value === 'add_card') {
                                        dispatch(setStep('5_pay_card'));
                                    } else {
                                        dispatch(setItem({id_payment: e.target.value}));
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            disablePointerEvents
                                            sx={{mr: 3, position: 'absolute', top: 'calc(50%)', right: 12}}>
                                            <Payment color="primary"/>
                                        </InputAdornment>
                                    ),
                                }}
                                disabled={loading}
                                select>
                                {payments && payments.map(o => (
                                    <MenuItem key={o.id} value={String(o.id)}>{o.name}</MenuItem>
                                ))}

                                <Divider/>

                                <MenuItem value="add_card">
                                    <ListItemIcon>
                                        <AddCard/>
                                    </ListItemIcon>
                                    Agregar tarjeta
                                </MenuItem>

                            </TextField>

                        </Grid>

                        <Grid xs={12} item>

                            <Typography color="white" variant="h5" fontWeight="bold">
                                ¿Tienes un código de descuento?
                            </Typography>

                        </Grid>

                        <Grid xs={12} item>

                            <TextField
                                label="Código"
                                value={code}
                                onChange={e => {
                                    setCode(e.target.value);
                                    setPromoRsp(undefined);
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Button
                                                onClick={addPromotion}
                                                disabled={!code || loading}>
                                                {promoRsp === null
                                                    ? <CircularProgress size={24} color="inherit"/>
                                                    : 'Aplicar'}
                                            </Button>
                                        </InputAdornment>
                                    ),
                                }}
                                error={promoRsp?.msg}
                                helperText={promoRsp?.msg}
                                disabled={loading}/>

                        </Grid>

                        {fareProduct && (
                            <Grid xs={12} item>

                                {fareProduct.price_promo > 0 && <>
                                    <Typography color="white" variant="h5" fontWeight="bold" textAlign="right">
                                        Subtotal: {coin(fareProduct.price)}
                                    </Typography>
                                    <Typography color="white" variant="h5" fontWeight="bold" textAlign="right">
                                        Descuento: {coin(fareProduct.price_promo)}
                                    </Typography>
                                </>}

                                <Typography color="white" variant="h5" fontWeight="bold" textAlign="right">
                                    Total a pagar: {coin(fareProduct.price - fareProduct.price_promo)}
                                </Typography>

                            </Grid>
                        )}

                        <Grid xs={12} md={6} item>

                            <Button
                                variant="contained"
                                startIcon={<ArrowBackIos/>}
                                onClick={() => {
                                    dispatch(setStep('2'));
                                }}
                                color="secondary"
                                disabled={loading}
                                fullWidth>
                                Volver
                            </Button>

                        </Grid>

                        <Grid xs={12} md={6} item>

                            <Button
                                variant="contained"
                                endIcon={<ArrowForwardIos/>}
                                onClick={createService}
                                disabled={loading || item.id_payment === ''}
                                fullWidth>
                                Crear Reserva
                            </Button>

                        </Grid>

                    </Grid>


                </Grid>

            </Grid>
        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step4));